// "Clés de détermination" - the only tag that gets the key-metadata control
// (see extend.php's `keyMetadata` field on DiscussionResource, gated to
// this same id server-side once a discussion exists). Mirrors champis-
// events' own eventsTag.js.
export const KEYS_TAG_ID = 1000082;
export function hasKeysTag(tags) {
  return (tags || []).some(t => t && String(t.id()) === String(KEYS_TAG_ID));
}
flarum.reg.add('champis-keys', 'forum/utils/keysTag', { KEYS_TAG_ID: KEYS_TAG_ID,hasKeysTag: hasKeysTag, });